import { Component, Inject, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';

export interface DialogData {
  icone: string;
  title: string;
  message: string;
  color: string;
  icon_color: string;
  dialogWidth: string;
  dialogHeight: string;
  result: string;
  required: boolean;
}

@Component({
  selector: 'app-add-comment-modal',
  templateUrl: './add-comment-modal.component.html',
  styleUrls: ['./add-comment-modal.component.scss']
})

export class AddCommentModalComponent implements OnInit {

  icone: string;
  title: string;
  message: string;
  color: string;
  icon_color: string;
  dialogWidth: string;
  dialogHeight: string;
  commForm: UntypedFormGroup;

  @Input() idSociety: number;
  constructor(public dialog: MatDialog,
              public router: Router,
              public dialogRef: MatDialogRef<Component>,
              @Inject(MAT_DIALOG_DATA) public data: DialogData) {
                this.commForm = this.getFormGroup();
              }

  ngOnInit(): void {
    this.icone = this.data.icone !== undefined ? this.data.icone : '';
    this.title = this.data.title !== undefined ? this.data.title : '';
    this.icon_color = this.data.icon_color !== undefined ? this.data.icon_color : '';
    this.dialogWidth = this.data.dialogWidth !== undefined ? this.data.dialogWidth : '';
    this.dialogHeight = this.data.dialogHeight !== undefined ? this.data.dialogHeight : '';
    this.color = this.data.color;
  }
  onModalCancel(): void {
    this.data.result = '';
    this.dialogRef.close(null);
  }

  onModalConfirm(): void {
    this.data.result = this.commForm.get('commentaires').value;
    if(this.data.required) {
      if (this.data.result.trim()) {
        this.dialogRef.close(this.data.result);
      } else {
        this.commForm.get("commentaires").patchValue("");
        this.commForm.updateValueAndValidity();
      }
    } else {
      this.dialogRef.close(this.data.result);
    }
  }

  getFormGroup(): UntypedFormGroup {
    const bcNumForm = new UntypedFormGroup({
      commentaires: new UntypedFormControl('', this.data.required ? Validators.required: null),
    });
    return bcNumForm;
  }
}
